"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _div;
const SidePanelSeparator = () => _div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  className: "relative h-[8px] bg-cloud-light -mx-xl"
}));
var _default = exports.default = SidePanelSeparator;